var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ComponentIds, } from "@inter-ikea-core/core";
import { SystemBase } from "../systembase/SystemBase";
import { SimpleOutlineModelSystem } from "./SimpleOutlineModelSystem";
/**
 * This system will configure all viewer objects to show block outlines (when the outlines are visible)
 * It acts mainly to preserve the legacy outline blocking behaviour, which set all models to show block
 * outlines.
 *
 * It will only affect viewer object created after the system was enabled.
 */
var AddBlockingToAllModelsSystem = /** @class */ (function (_super) {
    __extends(AddBlockingToAllModelsSystem, _super);
    function AddBlockingToAllModelsSystem() {
        var _this = _super.call(this, ComponentIds.VIEWER_OBJECT_COMPONENT_ID) || this;
        _this.id = AddBlockingToAllModelsSystem.systemID;
        _this.doingChangesOnComponent = [];
        _this.systemsAfterMe = [
            "OutlineSystem",
            SimpleOutlineModelSystem.systemID,
        ];
        _this.systemsBeforeMe = null;
        _this.mandatoryComponents = [
            ComponentIds.LOADED_MODEL_INFO_COMPONENT_ID,
        ];
        return _this;
    }
    AddBlockingToAllModelsSystem.prototype.onAddComponent = function (_entity, newComponent) {
        newComponent.viewerObject.setBlockOutlined(true);
    };
    AddBlockingToAllModelsSystem.prototype.onRemoveComponent = function (_entity, _oldComponent) {
        // Do nothing.
    };
    AddBlockingToAllModelsSystem.prototype.onUpdateComponent = function (_entity, _oldComponent, _newComponent) {
        // Do nothing.
    };
    AddBlockingToAllModelsSystem.systemID = "AddBlockingToAllModelsSystem";
    return AddBlockingToAllModelsSystem;
}(SystemBase));
export { AddBlockingToAllModelsSystem };
//# sourceMappingURL=AddBlockingToAllModelsSystem.js.map